import { doc, getDoc, getDocs, query, where } from 'firebase/firestore/lite';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { db, userData, userId } from '../../firebase.config';

function Address() {
    const [address, setAddress] = useState({})
    useEffect(() => {
    async function fetchAddress() {
      const userDoc = await getDocs(
        query(userData, where("uid", "==", userId))
      );
        const docId = userDoc.docs[0].id;

      const docRef = doc(db, "users", docId);
      const data = await getDoc(docRef, );

      setAddress(data.data().address)
      console.log("addrs",data.data().address);

      return 0;
    }
    fetchAddress();
}, []);
  console.log(address);

  return (
    <div className="h-screen">
      <div className="max-w-screen-xl mx-auto py-4 px-3  flex md:flex-row flex-col mt-24">
        <div className="w-full md:w-2/5 h-5/6  bg-slate-300 py-6 px-4 mx-auto rounded-xl">
          <div className="flex flex-col gap-6 tracking-wider border-b-[2px] border-b-slate-500 pb-6">
            <h2 className="text-2xl font-bodyFont font-bold text-center">
              Shipping Details
            </h2>

            <p className="flex items-start gap-4 text-base font-semibold">
              Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
              <span className="font-extrabold">
                {address.name ? address.name : "Your Name"}
              </span>
            </p>
            <p className="flex items-start gap-4 text-base font-semibold">
              Mobile &nbsp;&nbsp;:
              <span className="font-bold">
                {address.mobile ? address.mobile : "Unavailable"}
              </span>
            </p>
            <p className="flex items-start gap-4 text-base font-semibold">
              Address&nbsp;:
              <span className="font-bold">
                {/* PsychoHome, PsychoAdress, PsychoLocation, PsychoState, PsychoPin
              3637 */}
                {address.house
                  ? `${address.house}, ${address.landmark}, ${address.street}, ${address.city}, ${address.state} ${address.pin}`
                  : "Unavailable"}
              </span>
            </p>
          </div>
          <Link to={"/address/change"}>
            <div className="text-base text-center font-bodyFont rounded-lg font-semibold bg-slate-800 text-purple-200 hover:bg-slate-900 active:scale-105 duration-500 min-w-full py-3 mt-5 tracking-wider cursor-auto">
              {address? 'Edit' : 'AddNew'}
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Address